export default "__VITE_ASSET__gM3fdXck__"